//Angular

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { VehicleListComponent } from './vehicle-list.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ModalModule } from 'ngx-bootstrap/modal';
import { LoaderModule } from '../../shared/loader/loader.module';
import { VehicleRoutingModule } from './vehicle-routing.module';
import { VehicleDetailComponent } from './vehicleDetail.component';
import { ImportVehicleComponent } from './importVehicle.component';
import { ExpectedVehicleComponent } from './expectedVehicle.component';
import { CurrentVehicleComponent } from './currentVehicle.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    LoaderModule,
    ModalModule.forRoot(),
    ReactiveFormsModule,
    VehicleRoutingModule

  ],
  declarations: [
    VehicleListComponent,
    VehicleDetailComponent,
    ImportVehicleComponent,
    ExpectedVehicleComponent,
    CurrentVehicleComponent

  ]

})
export class vehicleModule { }
